import { useContext } from 'react'
import { TableCell, TableSortLabel } from "@material-ui/core"
import { ticketsContext } from "../TicketsContext";
import { TicketColumns } from "helpers/enums";


interface IProps {
    column: TicketColumns,
    text?: string
}

let TicketTableCell = ({ column, text }: IProps) => {
    let { search, updateSortColum } = useContext(ticketsContext)

    return (
        <TableCell>
            <TableSortLabel
                active={search.order?.column === column}
                onClick={() => updateSortColum(column)}
                direction={search.order?.column === column ? (search.order.descending ? 'desc' : 'asc') : undefined}
            >
                {text || column}
            </TableSortLabel>
        </TableCell>
    )
}

export default TicketTableCell
